module.exports = __webpack_public_path__ + "static/screen_1-4b30f5d18031de75fcebbd45979c59db.png";